import axios from "./axiosConfig";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const normalizePath = (url = '') => String(url).replace(/^\/+/, '');

// export const axiosClient = axios.create({
//   baseURL: 'http://localhost:8000'
// });

// axiosClient.defaults.headers = {
//   'Content-Type': 'application/json',
//   'Accept': 'application/json'
// };

// //All request will wait 2 seconds before timeout
// axiosClient.defaults.timeout = 5000;
// axiosClient.defaults.withCredentials = true;
// axiosClient.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;


// axios.interceptors.request.use(function (request) {
//   request.headers['Content-Type'] = 'multipart/form-data';
//   request.headers['token'] = 'ssssssssssss';
//   return request;
// }, null, { synchronous: true });


// axios.interceptors.response.use(function (response) {
//   //Dispatch any action on success
//   window.replace('/')

//   return response;
// }, function (error) {
//   if (error.response.status === 404) {
//     window.replace('/sdfsdf')

//     //Add Logic to 
//     //1. Redirect to login page or 
//     //2. Request refresh token
//   }
//   return Promise.reject(error);
// });

export function getRequest(URL, headers = null) {
  return axios.get(normalizePath(URL), headers).then(response => response);
}

export function postRequest(URL, payload, headers = null) {
  return axios.post(normalizePath(URL), payload, headers)
    .then(response => response)
    .catch(error => {
      if (error.response && (error.response.status === 400 || error.response.status === 409)) {
        MySwal.fire({
          title: 'Error',
          text: error?.response?.data?.message,
          icon: 'error',
          confirmButtonText: 'Ok',
        });
      } else {
        MySwal.fire({
          title: 'Error',
          text: 'Something Went Wrong Please Try Again !',
          icon: 'error',
          confirmButtonText: 'Ok',
        });
      }
      throw error; // 👈 important! rethrow so Login.js can catch it
    });
}

export function patchRequest(URL, payload, headers = null) {
  return axios.patch(normalizePath(URL), payload, headers).then(response => response)
  .catch((error)=> console.log(error));
}

export function deleteRequest(URL, headers = null) {
  return axios.delete(normalizePath(URL), headers).then(response => response);
}
